import { createAccountInfoFetcherStore } from './account-info-store'
import { createCartFetcherStore } from './cart-store'
import { createUserFetcherStore } from './user-store'
import { createAgentFetcherStore } from './agent-store'
import type { AgentUser } from '../../models/AgentUser'
import { setPersistentEngine } from '@nanostores/persistent'
import type { User } from '../../models/User'
import type { AccountData } from '../../models/AccountData'

/**
 * Sets up persistant stores storage to be session storage vs the default local storage
 */
export const initPersistentStores = () => {
  let listeners: any[] = []
  const events = {
    addEventListener(_key: string, callback: Function) {
      listeners.push(callback)
    },
    removeEventListener(_key: string, callback: Function) {
      listeners = listeners.filter((i) => i !== callback)
    },
    // window dispatches "storage" events for any key change
    // => One listener for all map keys is enough
    perKey: false,
  }

  setPersistentEngine(sessionStorage, events)
}

const getCacheLiftimeInMillis = (minutes: number) => {
  var date = new Date()
  date.setTime(date.getTime() + minutes * 60 * 1000)
  return date.getTime()
}

export const agentStore = createAgentFetcherStore<AgentUser | undefined>(['agent'])

export const userStore = createUserFetcherStore<User | undefined>([agentStore, 'user'], {
  cacheLifetime: getCacheLiftimeInMillis(60),
})

export const accountInfoStore = createAccountInfoFetcherStore<AccountData | undefined>([userStore, 'accountInfo'])

// TODO: eventually, we will want to make a dependency here for the cartStore to look at if the userStore updates and then refecth accordingly
// export const cartStore = createCartFetcherStore<any | undefined>(['cart', userStore])
export const cartStore = createCartFetcherStore<any | undefined>(['cart'])
